module.exports = __webpack_public_path__ + "static/img/32.dd125b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/32.png
// module id = Mu/g
// module chunks = 1